module.exports = __webpack_public_path__ + "static/media/penneli-solo.bfc32b0e.png";